var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "plant-item-modal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "PlantItemModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-xl modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm.plantItem !== undefined && _vm.plantItem.id === undefined
                    ? _c(
                        "h5",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "PlantItemModalLabel" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("addPlantItem")) + " ")]
                      )
                    : _vm._e(),
                  _vm.plantItem !== undefined && _vm.plantItem.id > 0
                    ? _c(
                        "h5",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "PlantItemModalLabel" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("editPlantItem")) + " ")]
                      )
                    : _vm._e(),
                  _vm._m(0),
                ]),
                _c(
                  "div",
                  { staticClass: "modal-body pt-3" },
                  [
                    _vm.loading === true ? _c("loading-spinner") : _vm._e(),
                    _vm.loading === false
                      ? _c("div", { staticClass: "tab-container" }, [
                          _c("ul", { staticClass: "tabs" }, [
                            _c(
                              "li",
                              {
                                class: {
                                  "tab-active": _vm.tabs.item.active === true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTab(_vm.tabs.item)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("plantItem")) + " ")]
                            ),
                            _c(
                              "li",
                              {
                                class: {
                                  "tab-active":
                                    _vm.tabs.operatingHours.active === true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTab(
                                      _vm.tabs.operatingHours
                                    )
                                  },
                                },
                              },
                              [_vm._v(" OH ")]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              style: {
                                display:
                                  _vm.tabs.item.active === true
                                    ? "block"
                                    : "none",
                              },
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("plantItemName"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.plantItem.name,
                                          expression: "plantItem.name",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.getValidateObject("name") ||
                                            _vm.isInputInvalid(
                                              _vm.plantItem.name
                                            ),
                                        },
                                        "form-control",
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("plantItemName"),
                                        required: "",
                                      },
                                      domProps: { value: _vm.plantItem.name },
                                      on: {
                                        change: _vm.handlePlantItemChange,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.plantItem,
                                            "name",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject("name"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("name"),
                                        function (error, index) {
                                          return _c(
                                            "span",
                                            { key: "nameError-" + index },
                                            [_vm._v(" " + _vm._s(error) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [_vm._v(_vm._s(_vm.$t("plantArea")))]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.plantItem.plantArea,
                                          expression: "plantItem.plantArea",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("plantArea"),
                                        disabled: "",
                                      },
                                      domProps: {
                                        value: _vm.plantItem.plantArea,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.plantItem,
                                            "plantArea",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _vm._m(1),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.selectedkks.text,
                                          expression: "selectedkks.text",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.getValidateObject("kksCode") ||
                                            _vm.isInputInvalid(
                                              _vm.selectedkks.text
                                            ),
                                        },
                                        "form-control",
                                      ],
                                      attrs: { type: "text", disabled: "" },
                                      domProps: { value: _vm.selectedkks.text },
                                      on: {
                                        change: _vm.handleKksTextChanged,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.selectedkks,
                                            "text",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject("kksCode"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("kksCode"),
                                        function (error, index) {
                                          return _c(
                                            "span",
                                            { key: "kksError-" + index },
                                            [_vm._v(" " + _vm._s(error) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.searchInput,
                                          expression: "searchInput",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "input-search",
                                        type: "text",
                                        placeholder: _vm.$t("typeSearch"),
                                        "aria-label": "Type to search...",
                                        "aria-describedby": "basic-addon2",
                                      },
                                      domProps: { value: _vm.searchInput },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.searchInput = $event.target.value
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-outline-secondary",
                                            attrs: {
                                              id: "btn-search",
                                              type: "button",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("search")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-outline-secondary",
                                            attrs: {
                                              id: "btn-clear-search",
                                              type: "button",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("clear")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._m(2),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _vm._m(3),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.plantItem.sapId,
                                          expression: "plantItem.sapId",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.getValidateObject("sapId"),
                                        },
                                        "form-control",
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: "SAP ID",
                                      },
                                      domProps: { value: _vm.plantItem.sapId },
                                      on: {
                                        change: function ($event) {
                                          return _vm.sapIdChange()
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.plantItem,
                                            "sapId",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject("sapId"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("sapId"),
                                        function (error, index) {
                                          return _c(
                                            "span",
                                            { key: "sapIdError-" + index },
                                            [_vm._v(" " + _vm._s(error) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("ohUsageFactor")
                                                ) +
                                                ": "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.plantItem.ohFactor,
                                          expression: "plantItem.ohFactor",
                                        },
                                      ],
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.getValidateObject("ohFactor") ||
                                            _vm.isInputInvalid(
                                              _vm.plantItem.ohFactor,
                                              1
                                            ),
                                        },
                                        "form-control",
                                      ],
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        max: "100",
                                        placeholder: _vm.$t("ohUsageFactor"),
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.plantItem.ohFactor,
                                      },
                                      on: {
                                        change: _vm.handleOhFactorChange,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.plantItem,
                                            "ohFactor",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._m(4),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject("ohFactor"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("ohFactor"),
                                        function (error, index) {
                                          return _c(
                                            "span",
                                            { key: "ohError-" + index },
                                            [_vm._v(" " + _vm._s(error) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _vm.data.selected.unit.enablePiConnection &&
                                _vm.data.selected.unit.piId
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [_vm._v(_vm._s(_vm.$t("piTag")))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.plantItem.piTag,
                                                expression: "plantItem.piTag",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.plantItem,
                                                  "piTag",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "" } },
                                              [_vm._v(" N/A ")]
                                            ),
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value:
                                                    _vm.data.selected.unit.piId,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.data.selected.unit
                                                        .piId
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "takeUnitParameters"
                                                      )
                                                    ) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.plantItemPiTags,
                                              function (piTag, index) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: "piTag-" + index,
                                                    domProps: { value: piTag },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(piTag) + " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _vm._m(5),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.plantItem.sapLocationCode,
                                          expression:
                                            "plantItem.sapLocationCode",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "SAP Location Code",
                                      },
                                      domProps: {
                                        value: _vm.plantItem.sapLocationCode,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.plantItem,
                                            "sapLocationCode",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [_vm._v(_vm._s(_vm.$t("PMHMapping")))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.plantItem.enerlyticsId,
                                            expression:
                                              "plantItem.enerlyticsId",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.plantItem,
                                              "enerlyticsId",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.enerlyticsData,
                                        function (entry, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: "plantInfo-" + index,
                                              staticClass: "plant-info",
                                              domProps: {
                                                value: entry.itemEnerlyticsId,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    entry.itemEnerlyticsId
                                                      ? _vm.$t("plantItem") +
                                                          ": " +
                                                          entry.itemName +
                                                          " | " +
                                                          _vm.$t("plantArea") +
                                                          entry.areaName
                                                      : entry.itemName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              style: {
                                display:
                                  _vm.tabs.operatingHours.active === true
                                    ? "block"
                                    : "none",
                              },
                            },
                            [
                              _vm.itemOperatingHours.years !== undefined
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { id: "plant-item-accordion" },
                                    },
                                    _vm._l(
                                      _vm.itemOperatingHours.years,
                                      function (year, yearIdx) {
                                        return _c(
                                          "pui-collapsible",
                                          {
                                            key: "year-" + yearIdx,
                                            staticClass: "card",
                                            attrs: { open: false },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-header-item",
                                                attrs: {
                                                  slot: "collapsibleHeader",
                                                  id:
                                                    "plantItemHeadingOne" +
                                                    year.year,
                                                },
                                                slot: "collapsibleHeader",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row mt-1 ml-1",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-1" },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  year.year
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group input-group-sm col-2 pr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text",
                                                              },
                                                              [_vm._v("EOH")]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.yearValue[
                                                                  year.year
                                                                ].eoh,
                                                              expression:
                                                                "yearValue[year.year].eoh",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].eoh"
                                                                ),
                                                            },
                                                            "form-control",
                                                          ],
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                            placeholder: "EOH",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.yearValue[
                                                                year.year
                                                              ].eoh,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.yearChange(
                                                                year,
                                                                4
                                                              )
                                                            },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.yearValue[
                                                                  year.year
                                                                ],
                                                                "eoh",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "invalid-feedback":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].eoh"
                                                                ),
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "years[" +
                                                                yearIdx +
                                                                "].months[0].eoh"
                                                            ),
                                                            function (
                                                              error,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key:
                                                                    "eohError-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        error
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group input-group-sm col-2 pr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text",
                                                              },
                                                              [_vm._v("OH")]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.yearValue[
                                                                  year.year
                                                                ]
                                                                  .operatingHours,
                                                              expression:
                                                                "yearValue[year.year].operatingHours",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].operatingHours"
                                                                ),
                                                            },
                                                            "form-control",
                                                          ],
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                            placeholder: "OH",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.yearValue[
                                                                year.year
                                                              ].operatingHours,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.yearChange(
                                                                year,
                                                                0
                                                              )
                                                            },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.yearValue[
                                                                  year.year
                                                                ],
                                                                "operatingHours",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "invalid-feedback":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].operatingHours"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "years[" +
                                                                yearIdx +
                                                                "].months[0].operatingHours"
                                                            ),
                                                            function (
                                                              error,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key:
                                                                    "ohError-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        error
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group input-group-sm col-2 pr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text hot-starts",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t("hs")
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.yearValue[
                                                                  year.year
                                                                ].hotStarts,
                                                              expression:
                                                                "yearValue[year.year].hotStarts",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].hotStarts"
                                                                ),
                                                            },
                                                            "form-control",
                                                          ],
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                            placeholder:
                                                              _vm.$t(
                                                                "hotStarts"
                                                              ),
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.yearValue[
                                                                year.year
                                                              ].hotStarts,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.yearChange(
                                                                year,
                                                                1
                                                              )
                                                            },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.yearValue[
                                                                  year.year
                                                                ],
                                                                "hotStarts",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "invalid-feedback":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].hotStarts"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "years[" +
                                                                yearIdx +
                                                                "].months[0].hotStarts"
                                                            ),
                                                            function (
                                                              error,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key:
                                                                    "hotStartsError-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        error
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group input-group-sm col-2 pr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text warm-starts",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t("ws")
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.yearValue[
                                                                  year.year
                                                                ].warmStarts,
                                                              expression:
                                                                "yearValue[year.year].warmStarts",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].warmStarts"
                                                                ),
                                                            },
                                                            "form-control",
                                                          ],
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                            placeholder:
                                                              _vm.$t(
                                                                "warmStarts"
                                                              ),
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.yearValue[
                                                                year.year
                                                              ].warmStarts,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.yearChange(
                                                                year,
                                                                2
                                                              )
                                                            },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.yearValue[
                                                                  year.year
                                                                ],
                                                                "warmStarts",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "invalid-feedback":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].warmStarts"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "years[" +
                                                                yearIdx +
                                                                "].months[0].warmStarts"
                                                            ),
                                                            function (
                                                              error,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key:
                                                                    "warmStartsError-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        error
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group input-group-sm col-2 pr-0",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text cold-starts",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t("cs")
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.yearValue[
                                                                  year.year
                                                                ].coldStarts,
                                                              expression:
                                                                "yearValue[year.year].coldStarts",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].coldStarts"
                                                                ),
                                                            },
                                                            "form-control",
                                                          ],
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                            placeholder:
                                                              _vm.$t(
                                                                "coldStarts"
                                                              ),
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.yearValue[
                                                                year.year
                                                              ].coldStarts,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.yearChange(
                                                                year,
                                                                3
                                                              )
                                                            },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.yearValue[
                                                                  year.year
                                                                ],
                                                                "coldStarts",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "invalid-feedback":
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].coldStarts"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "years[" +
                                                                yearIdx +
                                                                "].months[0].coldStarts"
                                                            ),
                                                            function (
                                                              error,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key:
                                                                    "coldStartsError-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        error
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", {
                                                      staticClass: "col-1",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-content",
                                                attrs: {
                                                  id:
                                                    "collapsePlantItemaccordion" +
                                                    year.year,
                                                },
                                              },
                                              _vm._l(
                                                year.months,
                                                function (month, monthIdx) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: "month-" + monthIdx,
                                                      staticClass: "row ml-1",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-1",
                                                        },
                                                        [
                                                          _c("h6", [
                                                            _vm._v(
                                                              _vm._s(
                                                                month.month
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm col-2 pr-0",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text",
                                                                },
                                                                [_vm._v("EOH")]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  month.eoh,
                                                                expression:
                                                                  "month.eoh",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            class: [
                                                              {
                                                                "is-invalid":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].eoh"
                                                                  ),
                                                              },
                                                              "form-control",
                                                            ],
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              placeholder:
                                                                "EOH",
                                                            },
                                                            domProps: {
                                                              value: month.eoh,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.monthChange(
                                                                  year
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  month,
                                                                  "eoh",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "invalid-feedback":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].eoh"
                                                                  ),
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "years[" +
                                                                  yearIdx +
                                                                  "].months[" +
                                                                  monthIdx +
                                                                  "].eoh"
                                                              ),
                                                              function (
                                                                error,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      "montheohError-" +
                                                                      index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        error
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm col-2 pr-0",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text",
                                                                },
                                                                [_vm._v("OH")]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  month.operatingHours,
                                                                expression:
                                                                  "month.operatingHours",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            class: [
                                                              {
                                                                "is-invalid":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].operatingHours"
                                                                  ),
                                                              },
                                                              "form-control",
                                                            ],
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              placeholder: "OH",
                                                            },
                                                            domProps: {
                                                              value:
                                                                month.operatingHours,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.monthChange(
                                                                  year
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  month,
                                                                  "operatingHours",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "invalid-feedback":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].operatingHours"
                                                                  ),
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "years[" +
                                                                  yearIdx +
                                                                  "].months[" +
                                                                  monthIdx +
                                                                  "].operatingHours"
                                                              ),
                                                              function (
                                                                error,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      "monthohError-" +
                                                                      index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          error
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm col-2 pr-0",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text hot-starts",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "hs"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  month.hotStarts,
                                                                expression:
                                                                  "month.hotStarts",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            class: [
                                                              {
                                                                "is-invalid":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].hotStarts"
                                                                  ),
                                                              },
                                                              "form-control",
                                                            ],
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              placeholder:
                                                                _vm.$t(
                                                                  "hotStarts"
                                                                ),
                                                            },
                                                            domProps: {
                                                              value:
                                                                month.hotStarts,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.monthChange(
                                                                  year
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  month,
                                                                  "hotStarts",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "invalid-feedback":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].hotStarts"
                                                                  ),
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "years[" +
                                                                  yearIdx +
                                                                  "].months[" +
                                                                  monthIdx +
                                                                  "].hotStarts"
                                                              ),
                                                              function (
                                                                error,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      "monthHotStartsError-" +
                                                                      index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          error
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm col-2 pr-0",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text warm-starts",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "ws"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  month.warmStarts,
                                                                expression:
                                                                  "month.warmStarts",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            class: [
                                                              {
                                                                "is-invalid":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].warmStarts"
                                                                  ),
                                                              },
                                                              "form-control",
                                                            ],
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              placeholder:
                                                                _vm.$t(
                                                                  "warmStarts"
                                                                ),
                                                            },
                                                            domProps: {
                                                              value:
                                                                month.warmStarts,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.monthChange(
                                                                  year
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  month,
                                                                  "warmStarts",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "invalid-feedback":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].warmStarts"
                                                                  ),
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "years[" +
                                                                  yearIdx +
                                                                  "].months[" +
                                                                  monthIdx +
                                                                  "].warmStarts"
                                                              ),
                                                              function (
                                                                error,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      "monthHotStartsError-" +
                                                                      index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          error
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm col-2 pr-0",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-prepend",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "input-group-text cold-starts",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "cs"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  month.coldStarts,
                                                                expression:
                                                                  "month.coldStarts",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            class: [
                                                              {
                                                                "is-invalid":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].coldStarts"
                                                                  ),
                                                              },
                                                              "form-control",
                                                            ],
                                                            attrs: {
                                                              type: "number",
                                                              min: "0",
                                                              placeholder:
                                                                _vm.$t(
                                                                  "coldStarts"
                                                                ),
                                                            },
                                                            domProps: {
                                                              value:
                                                                month.coldStarts,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.monthChange(
                                                                  year
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  month,
                                                                  "coldStarts",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "invalid-feedback":
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].coldStarts"
                                                                  ),
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "years[" +
                                                                  yearIdx +
                                                                  "].months[" +
                                                                  monthIdx +
                                                                  "].coldStarts"
                                                              ),
                                                              function (
                                                                error,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      "monthColdStartsError-" +
                                                                      index,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          error
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                      _c("div", {
                                                        staticClass: "col-1",
                                                      }),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-dismissible fade",
                        class: {
                          show: _vm.showResultBox,
                          "alert-success": !_vm.resultError,
                          "alert-danger": _vm.resultError,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.result) + " ")]
                    ),
                    _vm.errorMessage
                      ? _c("div", { staticClass: "my-1" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 alert alert-danger show" },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.showUnvisitedTabsMessage === true
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "alert alert-danger alert-dismissible fade",
                            class: { show: _vm.showUnvisitedTabsMessage },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("unvisitedTabsMessage")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.plantItem !== null &&
                  _vm.plantItem.id > 0 &&
                  _vm.tabs.item.active === true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm delete-button",
                          attrs: {
                            type: "button",
                            disabled:
                              !_vm.userHasWriteAccess || _vm.waitingForSave,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.confirmDeletePlantItem()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("delete")) + " ")]
                      )
                    : _vm._e(),
                  _vm.tabs.operatingHours.active === true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm copy-oh-button",
                          attrs: {
                            type: "button",
                            disabled:
                              !_vm.userHasWriteAccess || _vm.waitingForSave,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyOperatingHoursFromUnit()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("copyFromUnit")) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "wait",
                      class: { "fade-in": _vm.waitingForSave === true },
                    },
                    [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: {
                        type: "button",
                        disabled: _vm.waitingForSave,
                        "data-dismiss": "modal",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        type: "button",
                        disabled: !_vm.userHasWriteAccess || _vm.waitingForSave,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addPlantItem()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("saveChanges")) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("confirm-snackbar", {
        attrs: {
          open: _vm.deleteSnackbarOpen,
          "callback-function": _vm.deletePlantItem,
          message: _vm.$t("confirmDelete"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("KKS")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3" }, [
      _c("div", { attrs: { id: "kkstree" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("SAP ID")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text" }, [_vm._v(" % ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _vm._v("SAP Functional Location Code"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }